define([
  "jquery", "store"],
function ($, store) {
  var LocalStorage = function () { };

  $.extend(LocalStorage.prototype, {

    getFromLocalStorage: function (key, defaultValue) {
      var value = store.get(key)
      if (value) {
        return value;
      }
      return defaultValue;
    },

    persist: function (key, value) {
      store.set(key, value);
    },

    remove: function(key) {
      store.remove(key);
    }

  });

  return LocalStorage;

});
